import React, { memo } from 'react'
import Skeleton from '@jimmyboys/liita-ui/dist/components/Skeleton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import styles from './CommentCard.module.sass'
import CommentCardHeader, {
	renderCommentHeaderSkeleton,
} from './CommentCardHeader'
import FuseHighlight from 'components/FuseHighlight/FuseHighlight'

const CommentCard = memo(
	(props) => {
		const { className, data, ...attributes } = props
		const { openFile } = useGlobal()
		const labels = data.$cardLabels || {}

		const isTrustComment = data?.managementEntity

		return (
			<>
				<div
					{...attributes}
					className={`card ${styles['root'] || ''} ${
						className || ''
					} ${isTrustComment ? styles['trust-comment'] : ''}`}
				>
					<span className={styles['status-circle']} />
					<CommentCardHeader
						flipped={isTrustComment}
						data={data}
						labels={labels}
						openFile={openFile}
					/>
					{data.$detailLevel !== 'summary' && (
						<span
							className={`${styles['content']} ${
								isTrustComment ? styles['--flipped'] : ''
							}`}
						>
							<div className={styles['comment-header']}>
								<h5 className={styles['comment-title']}>
									{data.title || labels.commentTitle}
								</h5>
							</div>
							<div
								dynamic='true'
								className={styles['comment-body']}
							>
								<div
									style={{
										minHeight:
											!isNaN(data.textHeight) &&
											data.textHeight > 0
												? data.textHeight
												: undefined,
										maxHeight:
											!isNaN(data.textHeight) &&
											data.textHeight > 0
												? data.textHeight
												: undefined,
									}}
								>
									{data.body && (
										<FuseHighlight
											matchedWords={
												data.$textHighlight
													?.matchedIndexes?.['body']
											}
											text={data?.body}
										/>
									)}
								</div>
							</div>
						</span>
					)}
				</div>
			</>
		)
	},
	(prevProps, nextProps) =>
		prevProps.data.id === nextProps.data.id &&
		prevProps.data.textHeight === nextProps.data.textHeight &&
		prevProps.data.$layout === nextProps.data.$layout &&
		prevProps.data.$detailLevel === nextProps.data.$detailLevel &&
		prevProps.data.$textHighlight?.query ===
			nextProps.data.$textHighlight?.query &&
		prevProps.style.top === nextProps.style.top
)

CommentCard.displayName = 'CommentCard'
CommentCard.defaultHeight = 80
CommentCard.defaultSummaryHeight = 50
CommentCard.defaultLines = 0

export default CommentCard

export const CommentCardSkeleton = (props) => {
	const { className, ...attributes } = props

	return (
		<div
			{...attributes}
			className={`card ${styles['root'] || ''} ${className || ''} ${
				styles['skeleton-card']
			}`}
		>
			<span className={styles['status-circle']} />
			{renderCommentHeaderSkeleton()}
			<span className={`${styles['table']}`}>
				<div className={styles['comment-header']}>
					<h5>
						<Skeleton
							className={`${styles['skeleton']} ${styles['medium']}`}
						/>
					</h5>
				</div>
				<div
					className={`${styles['skeleton-comment']} ${styles['comment-body']}`}
				>
					<small>
						<Skeleton className={`${styles['skeleton']}`} />
					</small>
					<small>
						<Skeleton className={`${styles['skeleton']}`} />
					</small>
					<small>
						<Skeleton
							className={`${styles['skeleton']} ${styles['small']}`}
						/>
					</small>
				</div>
			</span>
		</div>
	)
}

CommentCardSkeleton.defaultHeight = 120
CommentCardSkeleton.verticalDefaultHeight = 130
